import { Box } from "@mui/material";
import React from "react";
import SideNav from "../../../agentComponents/sidenav";
import TicketTable from "./table";

const AgentTickets = () => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          bgcolor: "#F8F9FC",
        }}
      >
        <SideNav />
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            mt: { xs: "50px", md: 8 }
          }}
        >
          <TicketTable />
        </Box>
      </Box>
    </div>
  );
};

export default AgentTickets;
